export default "<p>common-functionality works!</p>\n"